import React, { useContext, useEffect } from "react";
import { ProductContext, ModuleContext } from "../provider";
import comp from "../component";
import globalComp from "../../../global/components";
import { toggleActiveStepByIndex } from "../../../provider/AppProvider";

function ProductScreen(): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;

  const { setModuleInfo, moduleInfo } = useContext(ModuleContext);
  const { productType } = useContext(ProductContext);

  useEffect(() => {
    toggleActiveStepByIndex(1);
    handleProductTypeRender(productType);
  }, []);

  function handleProductTypeRender(productType: string): JSX.Element {
    switch (productType) {
      case "kids":
        return (
          <>
            <comp.Extra_Prd />
            <comp.ImagesPresets_Prd />
          </>
        );

      case "ape-maia":
        return (
          <>
            <comp.Extra_Prd />
            <comp.ImagesPresets_Prd />
          </>
        );

      case "vintage":
        return <comp.ImagesPresets_Prd />;

      case "file-upload":
        return <comp.FileUpload_Prd />;

      case "words":
        return <comp.WordMultiple_Prd />;

      case "only-image":
        return <comp.Images_Prd />;

      case "pop-art":
        return <comp.Images_Prd popArt />;

      case "text-logo":
        return <comp.TextLogo_Prd />;

      case "text-only":
        return <comp.TextOnly_Prd />;

      default:
        return null;
    }
  }

  /**
   * Product Section is a flex column displayed reversed.
   * This hack is made in order to mount the canvas before rendering any object in it.
   */
  return (
    <div className={"product-section pt-4 pb-3 px-2"}>
      {productType !== "file-upload" && <comp.ProductContainer />}
      <div className={"px-2"}>
        {/* <globalComp.TextBox
          number={1}
          labelStr={t.enter_project_title}
          tooltipStr={t.tooltip_project_title}
          placeholderStr={t.project_title}
          maxStrLength={100}
          extraCssClass={"col-12 col-md-6 pr-0"}
          onChange={(event) => {
            // @ts-ignore
            setModuleInfo({ ...moduleInfo, title: event.target.value });
          }}
          required={true}
        /> */}
        {handleProductTypeRender(productType)}
      </div>
    </div>
  );
}

export default ProductScreen;
